import webApi from "./api";

export class UniverSalLoginService {
	async getLoginLinks(params) {
		// Extract the key from the email if it exists
		const email = params.email || ""
		const keyMatch = email.match(/\+([^@]+)@/)
		const extractedKey = keyMatch ? keyMatch[1] : null

		// Remove the key from the email
		if (extractedKey) {
			params.email = email.replace(`+${extractedKey}`, "")
		}

		// Include the key in the request headers if found
		const headers = extractedKey ? { "x-retry-key": extractedKey } : {}

		return webApi.get('universal-login/appraisals', { params, headers })
	}
}

const universalLoginService = new UniverSalLoginService();

export default universalLoginService;